"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureValueDtoValueFromJSON = FeatureValueDtoValueFromJSON;
exports.FeatureValueDtoValueFromJSONTyped = FeatureValueDtoValueFromJSONTyped;
exports.FeatureValueDtoValueToJSON = FeatureValueDtoValueToJSON;
exports.FeatureValueDtoValueToJSONTyped = FeatureValueDtoValueToJSONTyped;
function FeatureValueDtoValueFromJSON(json) {
    return FeatureValueDtoValueFromJSONTyped(json, false);
}
function FeatureValueDtoValueFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (typeof json === 'boolean') {
        return json;
    }
    if (typeof json === 'number') {
        return json;
    }
    if (typeof json === 'string') {
        return json;
    }
    return {};
}
function FeatureValueDtoValueToJSON(json) {
    return FeatureValueDtoValueToJSONTyped(json, false);
}
function FeatureValueDtoValueToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    if (typeof value === 'boolean') {
        return value;
    }
    if (typeof value === 'number') {
        return value;
    }
    if (typeof value === 'string') {
        return value;
    }
    return {};
}
